// THIS COMPONENT IS DEPRECATED. PLEASE USE THE NEW COMPONENT IN THE @unite-us/app-components LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import InfoPanel from "../InfoPanel/InfoPanel";

/**
 * @visibleName NoteDisclosure DEPRECATED
*/

// eslint-disable-next-line max-len
var NOTE_DISCLOSURE_MESSAGE = "Include any additional information about why you're rejecting this referral. Don't include any sensitive information (such as details about interpersonal violence, substance use, or legal services).";
var NoteDisclosure = function NoteDisclosure(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(InfoPanel, {
    className: className,
    message: NOTE_DISCLOSURE_MESSAGE
  });
};
NoteDisclosure.propTypes = {
  /* Class name */
  className: PropTypes.string
};
NoteDisclosure.defaultProps = {
  className: ''
};
export default NoteDisclosure;